const CHUNK_SIZE = 50;
const TIMEOUT = 1000;

export async function PromiseAllChunked<T>(allTasks: (() => Promise<T>)[]) {
  try {
    const chunks: (() => Promise<T>)[][] = [];
    chunks.push([]);
    allTasks.forEach((task) => {
      const i = chunks.length - 1;
      if (chunks[i].length < CHUNK_SIZE) {
        chunks[i].push(task);
      } else {
        chunks.push([task]);
      }
    });

    let results: T[] = [];
    results = await Promise.all(chunks[0].map((task) => task()));
    for (const chunk of chunks.slice(1)) {
      await new Promise<void>((resolve) => setTimeout(() => resolve(), TIMEOUT));
      const more: T[] = await Promise.all(chunk.map((task) => task()));
      results = [...results, ...more];
    }

    return results;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
